import notificationsActionTypes from '../../constants/actions/notifications/notifications'

export function initialState () {
  return {
    notificationCount: {
      documents: null,
      dossiers: null
    },
    documentNotifications: [],
    showDocumentPopover: false,
    dossierNotifications: [],
    showDossierPopover: false
  }
}

function setNotificationsCounter (state, { notificationCount: { documents = null, dossiers = null } }) {
  return {
    ...state,
    notificationCount: {
      documents: (documents !== null ? documents : state.notificationCount.documents),
      dossiers: (dossiers !== null ? dossiers : state.notificationCount.dossiers)
    }
  }
}

function closeDocumentNotificationPopover (state) {
  return {
    ...state,
    documentNotifications: [],
    showDocumentPopover: false
  }
}

function closeDossierNotificationPopover (state) {
  return {
    ...state,
    dossierNotifications: [],
    showDossierPopover: false
  }
}

export default function (state = initialState(), action) {
  switch (action.type) {
    case notificationsActionTypes.SET_NOTIFICATIONS_COUNTER:
      return setNotificationsCounter(state, action)
    case notificationsActionTypes.CLOSE_DOCUMENT_NOTIFICATIONS_POPOVER:
      return closeDocumentNotificationPopover(state, action)
    case notificationsActionTypes.CLOSE_DOSSIER_NOTIFICATIONS_POPOVER:
      return closeDossierNotificationPopover(state, action)
    default:
      return state
  }
}
